<button [disabled]="isDisabled" class="button is-small" (click)="_toggle()" data-ui-name="Toggle" data-ui-component="table-row-selector" data-testid="table-row-selector-toggle">
  <span class="checkbox-icon" [ngSwitch]="isDisplaySelected()">
    <i *ngSwitchCase="true" class="fa fa-check-square" aria-hidden="true"></i>
    <i *ngSwitchDefault class="far fa-square" aria-hidden="true"></i>
  </span>
</button>